import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { organizationActions } from "../../store/organization-store/organization-slice";
import { uiActions } from "../../store/ui-slice";
import { getTokenInfo } from "../../utils/Guard";
import { GetCountries } from "../../store/country-store/country-actions";
import { Dropdown } from "primereact/dropdown";

let restartPage = false;

const OrganizationForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const organization = props.organization;
  const isValid = useSelector(
    (state) => state.organization.organizationValidation
  );
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);
  const countries = useSelector((state) => state.country.countries);
  const organization =useSelector((state)=>state.organization.organization)
  const [selectedCountry, setSelectedCountry] = useState(null);

  let fitlerCountries = countries.filter(
    (country) => country.status === "Activo"
  );
  useEffect(() => {
    if (
      organization !== null &&
      organization !== undefined &&
      organization.id !== undefined &&
      organization.id > 0
    ) {
      if (organization.country !== undefined && organization.country !== null && organization.country.id > 0 && organization.country.id !== null && organization.country.id !== undefined) {
        setSelectedCountry({
          id: organization.country.id,
          code: organization.country.code,
          name: organization.country.name,
        });
      }
      
    }
  }, [organization]);

  useEffect(() => {
    if (countries && countries.length === 0) {
      dispatch(GetCountries(userInfo.Email, false));
    }
  }, [countries, dispatch, userInfo.Email]);

  useEffect(() => {
    if (
      organization !== undefined &&
      organization.id !== undefined &&
      organization.id > 0 &&
      organization.country ==! null &&
      organization.country.id ==! null
    ) {
      if (organization.country !== undefined && organization.country !== null) {
        setSelectedCountry({
          id: organization.country.id,
          code: organization.country.code,
          name: organization.country.name,
        });
      }
    }
  }, [organization]);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      organization.id > 0 &&
      restartPage
    ) {
      dispatch(organizationActions.restartState());
      window.location.href = "/organization";
    }
  }, [organization.id, dispatch, navigate, notification]);

  const onChangeCountriesHandler = (id, value) => {
    
    dispatch(organizationActions.modifyPropertyValue({ id, value: value.id }));
    if (value !== "") {
      dispatch(organizationActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(organizationActions.setFieldValid({ id, value: false }));
    }
    setSelectedCountry({
      id: value.id,
      code: value.code,
      name: value.name,
    });
  };
  const selectedCountryTemplate = (option, props) => {
    if (
      selectedCountry &&
      selectedCountry.id !== undefined &&
      selectedCountry.id > 0
    ) {
      return (
        <div className="flex align-items-center">
          <img
            alt={selectedCountry.name}
            src={`https://flagcdn.com/48x36/${selectedCountry.code.toLowerCase()}.png`}
            style={{ width: "10%", marginRight: "1%" }}
          />

          <div>{selectedCountry.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option) => {
    return (
      <div
        className="flex align-items-center"
        style={{ width: "70%" }}
      >
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "10%" }}>{option.name}</div>
      </div>
    );
  };

  const onChangeHandler = (id, value) => {
    dispatch(organizationActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(organizationActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(organizationActions.setFieldValid({ id, value: false }));
    }
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    
    if (organization.name === "") {
      dispatch(organizationActions.setFieldValid({ id: "name", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } 
    else if (organization.identifier === "") {
      dispatch(organizationActions.setFieldValid({ id: "identifier", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.countryId === "") {
      dispatch(organizationActions.setFieldValid({ id: "countryId", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.city === "") {
      dispatch(organizationActions.setFieldValid({ id: "city", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.zipCode === "") {
      dispatch(organizationActions.setFieldValid({ id: "zipCode", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.address === "") {
      dispatch(organizationActions.setFieldValid({ id: "address", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.email === "") {
      dispatch(organizationActions.setFieldValid({ id: "email", value: false }));

      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else if (organization.ra === "") {
      dispatch(organizationActions.setFieldValid({ id: "ra", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    }
    else
    {
      dispatch(props.actionOrganization(organization, userInfo.Email));
      restartPage = true;
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Nombre:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {organization && organization.name && organization.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-4">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={organization.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor="identifier"
                style={{ fontSize: "large", color: "" }}
              >
                Identificador:
              </label>
              <InputText
                id="identifier"
                value={organization.identifier}
                onChange={(e) => onChangeHandler("identifier", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("identifier")}</div>
            </div>
            <div className="field col-12 md:col-4">
              <label
                htmlFor=" countryId"
                style={{ fontSize: "large", color: "", marginRight: "20%" }}
              >
                País:
              </label>
              <br />
              <Dropdown
                value={selectedCountry}
                onChange={(e) => {
                  onChangeCountriesHandler("countryId", e.value);
                }}
                options={fitlerCountries}
                optionLabel="name"
                placeholder="Seleccionar pais"
                valueTemplate={selectedCountryTemplate}
                filter
                itemTemplate={countryOptionTemplate}
                style={{
                  width: "100%",
                  height: "50%",
                }}
              />
              <div>{getFormErrorMessage("countryId")}</div>
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="city" style={{ fontSize: "large", color: "" }}>
                Ciudad:
              </label>
              <InputText
                id="city"
                value={organization.city}
                onChange={(e) => onChangeHandler("city", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("city")}</div>
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="zipCode" style={{ fontSize: "large", color: "" }}>
                Código Postal:
              </label>
              <InputText
                id="zipCode"
                value={organization.zipCode}
                onChange={(e) => onChangeHandler("zipCode", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
                <div>{getFormErrorMessage("zipCode")}</div>
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="address" style={{ fontSize: "large", color: "" }}>
                Dirección:
              </label>
              <InputText
                id="address"
                value={organization.address}
                onChange={(e) => onChangeHandler("address", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("address")}</div>
            </div>
            <div className="field col-12 md:col-3">
              <label htmlFor="Email" style={{ fontSize: "large", color: "" }}>
                Email:
              </label>
              <InputText
                id="Email"
                value={organization.email}
                onChange={(e) => onChangeHandler("email", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("email")}</div>
            </div>
            {/* <div className="field col-12 md:col-3">
              <label htmlFor="ra" style={{ fontSize: "large", color: "" }}>
                RA:
              </label>
              <InputText
                id="ra"
                value={organization.ra}
                onChange={(e) => onChangeHandler("ra", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("ra")}</div>
            </div> */}
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/organization");
              }}
            />
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default OrganizationForms;
